import React, {useEffect} from 'react';
import {observer} from 'mobx-react-lite'
import appStore from '../../../storage/AppStore'
import Input from '../../../ui/Input'
import Phone from '../../../ui/Phone'
import Btn from '../../../ui/Btn'
import clubStore from '../../../storage/ClubStore'

const Child = ({child, index, country}) => {
  const [required, setRequired] = React.useState(false);
  useEffect(() => {
    if (index === 0 || child.title || child.phone_number || child.year_born || child.forma_number) {
      setRequired(true);
    } else {
      setRequired(false);
    }
  }, [child.title, child.phone_number, child.year_born, child.forma_number]);
  return (
    <>
      <div className='col-md-8 position-relative'>
        <b>{appStore.tr.child} #{index+1}</b>
      </div>
      <div className='col-md-4 position-relative'>
        {index > 0 &&
          <Btn
            className="btn btn-danger btn-sm"
            onClick={() => {
              clubStore.member.remove_child(child)
            }}>
            <i className="ci ci-trash"/>&nbsp;  {appStore.tr.delete}
          </Btn>
        }
      </div>
      <div className="col-md-6 position-relative">
        <label htmlFor="input_title" className="form-label">{appStore.tr.title || 'Аты-жөнү'} *</label>
        <Input id={'input_title'} store={child} prop={'title'}
               label={appStore.tr.title || 'Аты-жөнү'} required={required}/>
      </div>
      <div className="col-md-6 position-relative">
        <label htmlFor="input_phone_number_child" className="form-label">{appStore.tr.phone_number}</label>
        <Phone
          id={'input_phone_number_child'}
          country={country || 'kg'} // Default country
          store={child}
          prop={'phone_number'}
          valid={"is_valid_phone_number"}
          required={required}
        />
      </div>
      <div className='col-md-6 position-relative'>
        <label htmlFor="input_year_born"
               className="form-label">{appStore.tr.year_born || 'Туулган жылы'}</label>
        <Input id={'input_year_born'} type={"number"} store={child} prop={'year_born'}
               label={appStore.tr.year_born || 'Туулган жылы'} required={required}/>
      </div>
      <div className='col-md-6 position-relative'>
        <label htmlFor="input_forma_number"
               className="form-label">{appStore.tr.forma_number || 'Форма номери'}</label>
        <Input id={'input_forma_number'} type={"number"} store={child} prop={'forma_number'}
               label={appStore.tr.forma_number || 'Форма номери'} required={required}/>
      </div>
      <hr/>
    </>
  );
}

export default observer(Child);